export const routes = [
	{
		'title': 'ثبت شکایت',
		'icon':'fa fa-star',
		'path': '/dynamic/MassCreateCases',
		'hidden':'loggedOut',
	}
]